import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';

export default class Model extends ObservablePropertyDescriptorObject {

    scriptBeforeMount = new PropertyDescriptor('', '创建前', "脚本", "js", "#anticon-Documentation", {
        description: '该脚本将在部件创建前执行',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    scriptAfterMount = new PropertyDescriptor('', '创建后', "脚本", "js", "#anticon-Documentation", {
        description: '该脚本将在部件创建后执行',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    scriptAfterPropsReceived = new PropertyDescriptor('', '属性改变后', "脚本", "js", "#anticon-Documentation", {
        description: '该脚本将在部件的模型更换后执行',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    scriptBeforeUnmount = new PropertyDescriptor('', '销毁前', "脚本", "js", "#anticon-Documentation", {
        description: '该脚本将在部件销毁前执行',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    extendClass = new PropertyDescriptor(``, "扩展类名", "样式", "string", "#anticon-noClass", {
        description: "如果您觉得编辑器中的参数无法满足需求时，可以为控件自定义类名，然后使用 \"原生 HTML\" 控件来修改该类名的 CSS 样式。多个类名请使用空格分隔",
    });

    style = new PropertyDescriptor("", "扩展样式", "样式", "css", "#anticon-CSS", {
        catalogIndex: 90,
        description: "如果您觉得编辑器中的参数无法满足需求时，可以编写原生 CSS 来控制部件的外观和行为",
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
        // get: (val) => val || "{\n\t\n}",
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    toString() {
        return "设置";
    }

    hasScript() {
        return this.scriptAfterMount || this.scriptAfterPropsReceived || this.scriptBeforeUnmount || this.scriptBeforeMount;
    }
}
